import { Client } from '@web/api/src';
import {
  ReorderItemCheckDocument,
  ReorderItemCheckQuery,
  ReorderItemCheckQueryVariables,
} from '@/components/InventoryCarousel/orderLineItems.generated';
import { PLineItem } from '@/hooks/useUserLineItemsPagination';
import store from '@/store/store';
import { DeliveryType } from '@/types';
import { getItemDataFromArticle } from '@/utils/getItemDataFromArticle';
import { ArticleData, CartItemData } from '@agrantis/cart';
import {
  PriceData,
  getArticlePriceData,
} from '@agrantis/cart/getArticlePriceData';

type Delivery = {
  id: string;
  comments?: string | null;
  locationID?: string | null;
  siloID?: string | null;
  type: DeliveryType;
  siloName?: string | null;
  deliveryAddress?: {
    __typename?: 'OrderAddress';
    firstName?: string | null;
    lastName?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    addressLocality?: string | null;
    addressPostcode?: string | null;
    addressDistrict?: string | null;
    country?: string | null;
    company?: string | null;
  } | null;
};

export const getItemDataForLineItem = async (
  client: Client,
  lineItem: PLineItem,
): Promise<{
  itemData: CartItemData | null;
  delivery?: Delivery;
  priceData?: PriceData;
  shouldIncludeComments?: boolean;
}> => {
  const storeState = store.getState();
  const retailer = storeState.retailer.retailer;
  const hideVolumeDiscounts = retailer?.settings.hideVolumeDiscounts;
  const populateCommentsForReordering =
    retailer?.settings?.populateCommentsForReordering;

  const { data } = await client.query<
    ReorderItemCheckQuery,
    ReorderItemCheckQueryVariables
  >(ReorderItemCheckDocument, {
    inventoryId: `${lineItem?.inventory?.id}`,
    orderId: lineItem.order.id,
    retailerId: `${lineItem.order.retailerID}`,
  });

  const i = data?.inventory;
  const a = data?.inventory.articleData;
  const v = data?.inventory.volumeDiscounts || [];
  const priceTables = data?.retailer?.settings.priceTables;
  const customerGroupId = data?.currentUser?.erpCustomerGroupId;

  const createdByUser =
    data?.currentUser?.order?.createdByUser?.id === data?.currentUser?.id;

  const shouldIncludeComments =
    populateCommentsForReordering ||
    (!populateCommentsForReordering && createdByUser);

  if (i === undefined || a === undefined || a === null) {
    return { itemData: null };
  }

  const prices = data?.currentUser?.prices ?? [];

  const customerPrice = prices.find((price) => price.articleID === a?.id);

  const articleData: ArticleData = {
    ...a,
    volumeDiscounts: hideVolumeDiscounts ? [] : v,
    customerPrice,
    item: i,
  };

  const itemData = getItemDataFromArticle(articleData);

  const delivery = data?.currentUser?.order?.deliveries.find(
    (i) => i.id === lineItem?.delivery?.id,
  );

  if (!delivery) {
    console.warn('no delivery found');
    console.warn(data?.currentUser?.order);
    return { itemData };
  }

  const priceData = getArticlePriceData({
    item: articleData,
    livePrice: undefined, //liveprices not used in this context
    retailerPriceTables: priceTables,
    customerGroupId: customerGroupId,
  });

  return { delivery, itemData, priceData, shouldIncludeComments };
};
